import {Component, computed, input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {InvoiceKind} from '../../../api';

@Component({
  selector: 'elcia-invoice-kind-badge',
  imports: [TranslatePipe],
  templateUrl: './invoice-kind-badge.html',
  styleUrl: './invoice-kind-badge.scss',
  host: {class: 'inline-flex'},
})
export class InvoiceKindBadge {
  kind = input.required<InvoiceKind>();

  protected readonly badgeClass = computed(() => {
    switch (this.kind()) {
      case InvoiceKind.RECURRING:
        return 'bg-purple-100 text-purple-700';
      default:
        return 'bg-amber-100 text-amber-700';
    }
  });
}
